var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.91421L10.2929 7.20711C10.6834 7.59763 11.3166 7.59763 11.7071 7.20711C12.0976 6.81658 12.0976 6.18342 11.7071 5.79289L6.70711 0.792893C6.31658 0.402369 5.68342 0.402369 5.29289 0.792893L0.292893 5.79289C-0.0976311 6.18342 -0.0976311 6.81658 0.292893 7.20711C0.683418 7.59763 1.31658 7.59763 1.70711 7.20711L6 2.91421Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperIcon);
export default __webpack_public_path__ + "static/media/upper_icon.c62e046ec257959e2e3ff0b4ef68423d.svg";
export { ForwardRef as ReactComponent };